module.exports = __webpack_public_path__ + "img/bg3.cacb451d.jpg";